import { SpacingStyle, getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";
import { StickyStyle, stickyStyle } from "core/styles/containerStyle";
import styled from "styled-components";

export const Container = styled.div<SpacingStyle & StickyStyle>`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border: 1px solid ${({ theme }) => theme?.colors?.neutral?.neutral40};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  max-width: 200px;
  height: fit-content;

  ${getMarginStyle}
  ${getPaddingStyle}
  ${stickyStyle}
`;

export const MenuItem = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  flex-wrap: nowrap;
  width: 100%;
  background-color: ${({ isActive, theme }) => isActive && `${theme?.colors?.primary.surface}`};
  color: ${({ isActive, theme }) => isActive && `${theme?.colors?.primary.default}`};

  .filter-name {
    background-color: ${({ isActive, theme }) => isActive && `${theme?.colors?.primary.surface}`};
    color: ${({ isActive, theme }) => isActive && `${theme?.colors?.primary.default}`};
  }

  &:hover {
    background-color: ${({ theme }) => theme?.colors?.primary.surface};
    color: ${({ theme }) => theme?.colors?.primary.default};
    cursor: pointer;

    .filter-name {
      background-color: ${({ theme }) => theme?.colors?.primary.surface};
      color: ${({ theme }) => theme?.colors?.primary.default};
    }
  }
`;
